export const AcknowledgmentTitle = 'Information submitted successfully';

export const AcknowledgmentMessage = 'We have received your submission';

export const defaultLang = 'en-us';

export const SANITIZE_HTML_CONFIG = {
  allowedTags: [
    'b',
    'i',
    'u',
    'strong',
    'strike',
    'br',
    'span',
    'em',
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'sup',
    'sub',
    'code',
    'blockquote',
    'div',
    'pre',
    'ol',
    'ul',
    'li',
    'a',
    'img',
    'table',
    'tr',
    'td',
    'hr',
    'iframe',
  ],
  allowedAttributes: {
    '*': ['style'],
    a: ['href', 'target', 'rel'],
    img: ['src', 'alt'],
    div: ['data-substitutions'],
    iframe: ['width', 'height', 'src', 'frameborder'],
  },
  allowedStyles: {
    '*': {
      'font-family': [/^.*$/],
      'font-size': [/^.*$/],
      height: [/^.*$/],
      margin: [/^.*$/],
      'margin-top': [/^.*$/],
      'margin-right': [/^.*$/],
      'margin-bottom': [/^.*$/],
      'margin-left': [/^.*$/],
      padding: [/^.*$/],
      'padding-top': [/^.*$/],
      'padding-right': [/^.*$/],
      'padding-bottom': [/^.*$/],
      'padding-left': [/^.*$/],
      'text-align': [/^.*$/],
      'text-decoration': [/^.*$/],
      'text-transform': [/^.*$/],
      width: [/^.*$/],
      color: [/^.*$/],
      'background-color': [/^.*$/],
    },
  },
  selfClosing: ['img', 'br', 'hr'],
  allowedSchemes: ['http', 'https'],
  allowedSchemesByTag: {
    img: ['data'],
  },
};

export const ALLOWED_CONTENT_TYPES = [
  'application/gzip',
  'application/json',
  'application/msword',
  'application/ogg',
  'application/pdf',
  'application/rtf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.visio',
  'application/xhtml+xml',
  'application/xml',
  'application/zip',
  'application/x-zip-compressed',
  'audio/3gpp',
  'audio/3gpp2',
  'audio/mpeg',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'text/calendar',
  'text/csv',
  'text/html',
  'text/plain',
  'text/xml',
  'video/3gpp',
  'video/3gpp2',
  'video/mp2t',
  'video/mpeg',
  'video/ogg',
  'video/webm',
];

export const ALLOWED_EXTENSIONS = [
  { name: 'gzip', value: 'application/gzip' },
  { name: 'json', value: 'application/json' },
  { name: 'doc', value: 'application/msword' },
  { name: 'ogg', value: 'application/ogg' },
  { name: 'pdf', value: 'application/pdf' },
  { name: 'xls', value: 'application/vnd.ms-excel' },
  { name: 'ppt', value: 'application/vnd.ms-powerpoint' },
  { name: 'odp', value: 'application/vnd.oasis.opendocument.presentation' },
  { name: 'ods', value: 'application/vnd.oasis.opendocument.spreadsheet' },
  {
    name: 'pptx',
    value:
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  {
    name: 'odt',
    value:
      'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  },
  {
    name: 'odt',
    value:
      'application/vnd.openxmlformats-officedocument.presentationml.template',
  },
  {
    name: 'xlsx',
    value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  {
    name: 'odt',
    value:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  },
  {
    name: 'docx',
    value:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  { name: 'vsd', value: 'application/vnd.visio' },
  { name: 'xhtml', value: 'application/xhtml+xml' },
  { name: 'xml', value: 'application/xml' },
  { name: 'zip', value: 'application/zip' },
  { name: '3gp', value: 'audio/3gpp' },
  { name: '3g2', value: 'audio/3gpp2' },
  { name: 'mpeg', value: 'audio/mpeg' },
  { name: 'ogg', value: 'audio/ogg' },
  { name: 'wav', value: 'audio/wav' },
  { name: 'webm', value: 'audio/webm' },
  { name: 'jpeg', value: 'image/jpeg' },
  { name: 'jpg', value: 'image/jpg' },
  { name: 'png', value: 'image/png' },
  { name: 'gif', value: 'image/gif' },
  { name: 'svg', value: 'image/svg+xml' },
  { name: 'tiff', value: 'image/tiff' },
  { name: 'tif', value: 'image/tiff' },
  { name: 'webp', value: 'image/webp' },
  { name: 'ics', value: 'text/calendar' },
  { name: 'csv', value: 'text/csv' },
  { name: 'html', value: 'text/html' },
  { name: 'htm', value: 'text/html' },
  { name: 'txt', value: 'text/plain' },
  { name: '3gp2', value: 'text/xml' },
  { name: 'ts', value: 'video/mp2t' },
  { name: 'mpeg', value: 'video/mpeg' },
  { name: 'ogv', value: 'video/ogg' },
  { name: 'webm', value: 'video/webm' },
];

export enum FeatureFlags {}
